// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"66968e82","168":"b55b57c7","324":"1d238131","537":"582d6f47","794":"b5e02ab3","872":"a3fb7c59"}[chunkId] + ".chunk.css";
};